import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import config from '../constants/apiConfig';

/** These environment variables are sent from COMS after a user is authenticated. */
type EnvironmentVariables = {
  DEFAULT_FEATURE_FLAGS: string;
  MAPBOX_ACCESS_TOKEN: string;
  TINYMCE_API_KEY: string;
  OPEN_WEATHER_API_KEY: string;
  UNSPLASH_CLIENT_ID: string;
  POSTHOG_API_KEY: string;
  ARCGIS_API_KEY: string;
};

export const useEnvironmentVariables = (enabled: boolean = true) => {
  return useQuery({
    queryKey: ['environmentVariables'],
    queryFn: async () => {
      const response = await axios.get<EnvironmentVariables>(
        config.apiGateway.getEnvironmentVariables
      );
      return response.data;
    },
    enabled: enabled,
  });
};
